const join = {
  path: 'join',
  component: () => import("@/views/home/join/join.vue"),
  children: [
    {
      path: 'agent',          //VIP介绍 区县代理
      component: () => import("@/views/home/join/agent.vue"),
      meta: {
        tabBar: false,
        title:"慧联天下区域代理项目"
      },
    },
    {
      path: 'agent-city', // 市级代理项目页
      component: () => import("@/views/home/join/agent-city.vue"),
      meta: {
        tabBar: false,
        title: "慧联天下区域代理项目"
      },
    },
    {
      path: 'agent-apply',      //代理申请
      component: () => import("@/views/home/join/agent-apply.vue"),
      meta: {
        tabBar: false,
        title: "申请慧联天下代理"
      },
      children: [

      ]
    },
    {
      //代理申请成功
      path: 'agent-apply-success',
      component: () => import('@/views/home/join/agent-apply-success.vue'),
      meta: {
        tabBar: false,
        title: "申请代理"
      },
    },
    {
      path: 'vip',          //VIP介绍
      component: () => import("@/views/home/join/vip.vue"),
      meta: {
        tabBar: false
      },
      children:[
        {
          path: 'vip-package-detail',
          component: () => import('@/views/home/join/vip-package-detail.vue'),
          meta: {
            tabBar: false
          },
        }
      ]
    },
    {
      path: 'vip-buy',    //VIP购买
      component: () => import("@/views/home/join/vip-buy.vue"),
      meta: {
        tabBar: false
      },
    },
    {
      path: 'creator',    //创客介绍
      component: () => import("@/views/home/join/creator.vue"),
      meta: {
        tabBar: false
      },
    },{
      path: 'creator-detail',    //创客介绍
      component: () => import("@/views/home/join/creator-detail.vue"),
      meta: {
        tabBar: false
      },
    },
    {
      path:"details",
      component:() => import("@/views/home/join/details"),
      meta: {
        tabBar: false
      },
    },
    {
      path:"explain",
      component:() => import("@/views/home/join/explain"),
      meta: {
        tabBar: false
      },
    },
    {
      path:"operate",
      component:() => import("@/views/home/join/operate"),
      meta: {
        tabBar: false
      },
    },
    {
      path: 'creator-buy',    //创客购买
      component: () => import("@/views/home/join/creator-buy.vue"),
      meta: {
        tabBar: false
      },
    }
  ]
};

export default join;
